// extracted by mini-css-extract-plugin
export default {"trading_container":"trading_trading_container__2IOGH"};